import { styled as r } from "styled-components";
import { MediaQuery as t } from "../../../../../styles/variables.js";
import { CaptionHeavy as e } from "../../../../../styles/typography/index.js";
import { Icon as l } from "../../../../../components/Icon/index.js";
import { Colors as i } from "../../../../../styles/colors/index.js";
import { Theme as o } from "../../../../../styles/themes/index.js";
const b = r.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media ${t.SCREEN_MD_UP} {
    justify-content: flex-start;
  }
`, g = r.button`
  ${e}
  display: flex;
  align-items: center;
  color: rgb(${o.colors.Alpha});
  padding: 4px;
  border-radius: 24px;
  border: 1px solid rgb(${o.colors.Golf});
  background-color: rgb(${o.colors.Juliet});

  @media ${t.SCREEN_MD_UP} {
    &:hover {
      color: rgb(${o.colors.Alpha});
      background-color: rgb(${o.colors.Kilo});
    }
  }
`, m = r.button`
  ${e}
  display: flex;
  align-items: center;
  padding: 4px 12px 4px 8px;
  column-gap: 4px;
  border-radius: 24px;
  border: 1px solid rgb(${o.colors.Golf});
  background-color: rgb(${o.colors.Juliet});
  margin-right: 16px;

  &[data-inactive='true'] {
    color: rgb(${i.Gray});
  }

  @media ${t.SCREEN_MD_UP} {
    &:hover {
      background-color: rgb(${o.colors.Kilo});
    }
  }
`, u = r(l)`
  color: rgb(${o.colors.Brand});
  font-size: 24px;
  &[aria-disabled='true'] {
    color: rgb(${i.Gray});
  }
`;
export {
  b as Container,
  m as NotificationButton,
  g as SaveButton,
  u as SavedDealIcon
};
